import React from 'react';
import { Link } from 'react-router-dom';
import Process_1 from '../../../assets/images/svg/counter-1.svg';
import Process_2 from '../../../assets/images/svg/counter-2.svg';
import Process_3 from '../../../assets/images/svg/counter-3.svg';
import Process_4 from '../../../assets/images/svg/counter-4.svg';

const processSteps = [
    {
        id: 1,
        title: 'Plan for work',
        description: 'Consulting services give access to expertise than would be feasible to retain in house.',
        icon: Process_1,
        delay: '0ms',
    },
    {
        id: 2,
        title: 'Quotation',
        description: 'Campaigns are deployed to achieve client’s objectives. A strong return on investment is the main goal.',
        icon: Process_2,
        delay: '400ms',
    },
    {
        id: 3,
        title: 'Implementation',
        description: 'Quality and experienced design development services to start, manage, and grow Internet.',
        icon: Process_3,
        delay: '800ms',
    },
    {
        id: 4,
        title: 'Project Closure',
        description: 'Our people are the heart of our operations, which is why we’re fanatical about finding.',
        icon: Process_4,
        delay: '1200ms',
    },
];

const Process = () => {
    return (
        <>
            <div className="process-section-two">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 m-auto">
                            <div className="heading-box light text-center">
                                <span className="sub-title animate fadeInUp wow" data-wow-duration="1500ms">
                                    Our process
                                </span>
                                <h2 className="heading-title animate fadeInUp wow" data-wow-duration="1500ms" data-wow-delay="200ms">
                                    Steps of working with Uniqu consulting awesome team
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row gutter-y-30">
                        {processSteps.map((step) => (
                            <div className="col-xl-3 col-lg-4 col-md-6" key={step.id}>
                                <div className="process-box-two animate fadeInUp wow" data-wow-duration="1500ms" data-wow-delay={step.delay}>
                                    <div className="process-icon-two">
                                        <span>{`a${step.id}`}</span>
                                        <img src={step.icon} alt="icon" />
                                    </div>
                                    <h4>{step.title}</h4>
                                    <p>{step.description}</p>
                                    <Link to="/Contact" className="process-btn">
                                        <span>
                                            <svg width={20} height={6} viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20 3L15 0.113247L15 5.88675L20 3ZM4.37114e-08 3.5L15.5 3.5L15.5 2.5L-4.37114e-08 2.5L4.37114e-08 3.5Z" fill="white" />
                                            </svg>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Process;